import React, { useContext } from "react"
import { Box, Typography } from "@mui/material"
import TableStyleContext from "../TableStyleContext"

type Props = {
  recordsCount: number
  hideFooter?: boolean
}

const TableFooter: React.FC<Props> = ({ recordsCount, hideFooter = false }) => {
  const { classes } = useContext(TableStyleContext)

  if (hideFooter) {
    return null
  }

  return (
    <Box className={classes.footer}>
      <Typography variant="caption" color="muted">
        Displaying{" "}
        <Typography variant="caption" fontWeight="medium" component="span">
          {recordsCount}
        </Typography>{" "}
        Results
      </Typography>
    </Box>
  )
}

export default TableFooter
